import RncpVisualizationComponent from '../components/RncpVisualization'

export default function RncpVisualization() {
  return (
    <div className="h-full flex flex-col">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Visualisation RNCP</h1>
        <p className="text-gray-600 mt-1">
          Explorez les certifications RNCP et leurs compétences avec analyse de fusion intelligente
        </p>
      </div>

      <div className="flex-1">
        <RncpVisualizationComponent />
      </div>
    </div>
  )
}